import * as St from './index';

type ModalArrowDirection = 'left' | 'right';

type DesignSectionModalArrowProps = {
  direction: ModalArrowDirection;
  imgUrl: string;
  imgAlt: string;
  description: string;
  handleChange: (direction: ModalArrowDirection) => void;
};

const DesignSectionModalArrow = ({
  direction,
  imgUrl,
  imgAlt,
  description,
  handleChange,
}: DesignSectionModalArrowProps) => (
  <St.Container className={direction} onClick={() => handleChange(direction)}>
    <St.InnerCarouselImage src={imgUrl} alt={imgAlt} />
    <St.InnerCarouselContainer className={direction}>
      <St.InnerCarouselIcon
        className={direction}
        component={() =>
          direction === 'left' ? <St.LeftArrow /> : <St.RightArrow />
        }
      />
      <St.InnerCarouselSpan className={direction}>
        {description}
      </St.InnerCarouselSpan>
    </St.InnerCarouselContainer>
  </St.Container>
);

export default DesignSectionModalArrow;
